;(function() {
  'use strict'

  angular.module('core.subSelector', [])
})()
